var pug = require("!../../../../../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (field, hasStore, i18n, isForVNext) {pug_html = pug_html + "\u003Cdiv class=\"import-options-indented-section\"\u003E";
if (hasStore) {
var id = field.id;
pug_html = pug_html + "\u003Cselect" + (" class=\"form-control input\""+" role=\"listbox\""+pug.attr("id", id, true, true)+pug.attr("aria-label", field.ariaLabel, true, true)+pug.attr("aria-labelledby", id + "-Label", true, true)+pug.attr("aria-describedby", id + "-Validation", true, true)+" data-bind=\"value: observable\"") + "\u003E";
// iterate field.values
;(function(){
  var $$obj = field.values;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var option = $$obj[index];
pug_html = pug_html + "\u003Coption" + (" role=\"option\""+pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = field.valueMessages[index]) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var option = $$obj[index];
pug_html = pug_html + "\u003Coption" + (" role=\"option\""+pug.attr("value", option, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = field.valueMessages[index]) ? "" : pug_interp)) + "\u003C\u002Foption\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fselect\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv id=\"AdExtensionOptionsNoBmcMessage\"\u003E";
if (isForVNext) {
pug_html = pug_html + "\u003Cdiv class=\"iconba iconba-Warning\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"status_warning infoalign\"\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + (pug.escape(null == (pug_interp = i18n.getString('AdExtensions_Product_NoAccountsAvailable')) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";}.call(this,"field" in locals_for_with?locals_for_with.field:typeof field!=="undefined"?field:undefined,"hasStore" in locals_for_with?locals_for_with.hasStore:typeof hasStore!=="undefined"?hasStore:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"isForVNext" in locals_for_with?locals_for_with.isForVNext:typeof isForVNext!=="undefined"?isForVNext:undefined));;return pug_html;};
module.exports = template;